import { render, staticRenderFns } from "./PrivilegeTypesDropdown.vue?vue&type=template&id=3466ea1c"
import script from "./PrivilegeTypesDropdown.vue?vue&type=script&lang=js"
export * from "./PrivilegeTypesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports